<template>
  <div class="product-list">
    <product-list-item
      v-for="(item, index) in projects"
      :project="item"
      :img-height="imgHeight"
      :key="index"
    ></product-list-item>
  </div>
</template>

<script>
import ProductListItem from "@/components/common/productList/ProductListItem";
export default {
  name: "ProductList",
  props: ["projects", "imgHeight"],
  components: {
    ProductListItem,
  },
};
</script>

<style scoped>
@media screen and (min-width: 768px) {
  .product-list {
    margin-top:0px;
    margin-bottom: 30px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
}

@media screen and (max-width: 768px) {
  .product-list {
    margin-top:30px;
    display: flex;
    justify-content: center;
  }
}
</style>
